<template>
	<div style="margin-top:20px;">
		<div class="info-wrap">
			<table cellspacing="1" width="100%" class="order-info">
				<tr>
					<td>待支付定单编码：{{intentionBillMainVO.intentionBillRecordCode}}</td>
				</tr>
				<tr>
					<td>苗场：{{intentionBillMainVO.seedFarmName}}</td>
				</tr>
				<tr>
					<td>交货日期：{{getDateString(intentionBillMainVO.intentionBillRecordSendProductDate)}}</td>
				</tr>
                <tr>
                	<td>周次：{{intentionBillMainVO.weekSeq}} 周 </td>
                </tr>
               <!-- <tr>
                	<td>待付金额：{{intentionBillMainVO.remainingSum}}元 </td>
                </tr> -->
			</table>
		</div>

		<div class="dataTable">
			<b-table id="orderDetail-table" :fields="orderDetail.fields" :items="orderDetail.items" small bordered hover
				:busy="orderDetail.isTableBusy" caption-top>
				<template v-slot:cell(index)="row">
					<template v-if="!row.item.intentionBillDetailProductCode||row.item.intentionBillDetailProductCode=='定金收取(%)'">
						<span></span>
					</template>
					<template v-else>
						  {{ row.index + 1 }}
					</template>
				</template>
				<template v-slot:cell(intentionBillDetailOrderQuantity)="row">
					<template v-if="row.item.intentionBillDetailProductUnit=='合计'">
						<span>	{{ parseFloat(row.item.intentionBillDetailOrderQuantity.toFixed(2)) }}</span>
					</template>
					<template v-else>
							{{ row.item.intentionBillDetailOrderQuantity }}
					</template>
				</template>
				<template v-slot:cell(intentionBillDetailTotalMoney)="row">
					<template v-if="row.item.intentionBillDetailProductName=='折扣'||row.item.intentionBillDetailProductUnit=='合计'">
						<span>{{ parseFloat(row.item.intentionBillDetailTotalMoney.toFixed(2)) }}</span>
					</template>
					<template v-else>
						{{ row.item.intentionBillDetailTotalMoney }}
					</template>
				</template>
				<template slot="table-caption">
					<span style="font-weight: bold;">待支付定单详细信息:{{intentionBillMainVO.billCode}}</span>
					<!-- <span style="color:red;">请于{{intentionBillMainVO.sendProductDateBefore}}前打款支付余额。（交货日三天前）</span> -->
				</template>
				<div slot="table-busy" class="text-center text-info my-2">
					<b-spinner class="align-middle"></b-spinner>
					<strong>加载中...</strong>
				</div>
			</b-table>
			<p v-if="intentionBillMainVO.customerMsg != null">客户备注:<strong>{{intentionBillMainVO.customerMsg}}</strong></p>
			<!-- <div class="onPay">
				<b-button style="margin-right:20px;" size="20" @click="onPayDeposit">支付定金</b-button>
				<b-button variant="success" size="20"  @click="onPayBalance">支付余额</b-button>
			</div> -->
		</div>
	</div>
</template>

<script>
	import api from '@/api/api';
	import {
		formatDateTimeString,
		getDateString,
		numberToFixed
	} from '@/libs/utils';
	import search from '@/libs/search';
	import "@/style/global.css";
	export default {
		name: 'BookingOrderDetail',
		components: {
		},
		data() {
			return {
				orderDetail: {
					fields: [
						{
						    key: "index",
						    label: "序号"
						},
						{
                            key: "intentionBillDetailProductCode",
                            label: "品种编号"
                        },
                        {
                            label: "品种名称",
                            key: "intentionBillDetailProductName"
                        },
                        {
                            label: "单位",
                            key: "intentionBillDetailProductUnit"
                        },
                        {
                            label: '数量',
                            key: 'intentionBillDetailOrderQuantity'
                        },
                        {
                            label: '单价',
                            key: 'intentionBillDetailProductPrice'
                        },
                        {
                            label: '金额',
                            key: 'intentionBillDetailTotalMoney'
                        }
					],
					items: [],
					isTableBusy: false
				},
                intentionBillMainVO:{}
			};
		},
		mounted() {
			if (!this.checkMemberLogin()) {
				this.$router.push({
					name: "MemberLogin"
				});
				return;
			}
			this.getOrderDetailInfo();
		},
		methods: {
			formatDateTimeString,
			getDateString,
			numberToFixed,
			getOrderDetailInfo() {
				this.orderDetail.isTableBusy = true;
				api.webIntentionGetOrderDetail({
					intentionBillRecordUuid: this.$route.query.intentionBillRecordUuid
				}).then(res => {
					this.orderDetail.isTableBusy = false;
					if (res.code === 0) {
					    if (res.data.intentionBill != null) {
                            this.intentionBillMainVO = res.data.intentionBill;
					        this.orderDetail.items = res.data.intentionBill.detailList;
							this.handleOrderDetail(this.orderDetail.items);
					    }
					}
				});
			},
			handleOrderDetail(items){
              if(items.length>0){
				// intentionBillDetailOrderQuantity
				let totalQuantity=items.reduce((accumulator, current) => accumulator + current.intentionBillDetailOrderQuantity, 0);
				let totalMoney=items.reduce((accumulator, current) => accumulator + current.intentionBillDetailTotalMoney, 0);
				items.push({intentionBillDetailProductUnit:'合计',intentionBillDetailOrderQuantity:totalQuantity,intentionBillDetailTotalMoney:totalMoney});
				let depositDue=this.intentionBillMainVO.intentionBillRecordDepositDue;    //已付定金
				let discount=this.intentionBillMainVO.intentionBillRecordProductDiscount;  //折扣
				let packageFee=this.intentionBillMainVO.intentionBillRecordTotalPackageFee;    //包装费用
				let deliveryFee=this.intentionBillMainVO.intentionBillRecordTotalDeliveryFee;   //配送费用
				let pieces=this.intentionBillMainVO.intentionBillRecordTotalPieces;   //箱数
				let packageFeePre=0;              //包装费单价
				let deliveryFeePre=0;             //配送费单价
				if(pieces>0){
					packageFeePre=(packageFee/pieces).toFixed(2);
					deliveryFeePre=(deliveryFee/pieces).toFixed(2);
				}
				let depoRa=(depositDue*100/totalMoney).toFixed(0);
				let allTotalMoney=parseFloat((totalMoney-discount+deliveryFee+packageFee).toFixed(2));
				items.push({intentionBillDetailProductCode:'定金收取(%)',intentionBillDetailProductName:depoRa,intentionBillDetailProductPrice:'已付定金',intentionBillDetailTotalMoney:depositDue});
				items.push({intentionBillDetailProductName:'折扣',intentionBillDetailTotalMoney:discount});
				items.push({intentionBillDetailProductName:'包装费',intentionBillDetailOrderQuantity:pieces+'箱',intentionBillDetailProductPrice:packageFeePre,intentionBillDetailTotalMoney:packageFee});
				items.push({intentionBillDetailProductName:'配送费',intentionBillDetailOrderQuantity:pieces+'箱',intentionBillDetailProductPrice:deliveryFeePre,intentionBillDetailTotalMoney:deliveryFee});
				items.push({intentionBillDetailProductPrice:'总额',intentionBillDetailTotalMoney:allTotalMoney});
			  }
			}
						
		}
	};
</script>

<style>
	.date-before{
		margin-top: 20px;
		font-weight: bold;
		color: #ec4040;
	}
	.orderKey {
		text-align: right;
		font-size: 14px;
		font-weight: bold;
	}

	.orderValue {
		font-size: 14px;
	}


	/* 信息 */
	.info-wrap {
		width: 100%;
		border: 1px solid #efefef;
		margin: 20px auto;
		background-color: #fafafa;
		padding: 15px 0px;
	}

	.info-wrap .order-info td {
		padding: 5px 30px;
	}

	.info-wrap .order-info td:nth-child(even) {
		color: #a16e02;
	}



	/* 表格 */
	.dataTable {
		margin-top: 20px;
	}

	.dataTable th {
		background-color: #efefef;
		height: 32px;
		line-height: 32px;
	}

	.table.b-table.b-table-caption-top>caption {
		color: #333;
	}

	.table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #dbdbdb;
        font-size: 14px;
	}

	.table-bordered td,
	.table-bordered th {
		border: 1px solid #dbdbdb;
	}

	.table-sm td,
	.table-sm th {
		padding: 10px 5px;
	}

	/* 页码 */
	.page-link {
		color: #757575 !important;
	}

	.page-link:hover {
		color: #00b151 !important;
	}

	.page-item.active .page-link {
		color: #fff !important;
		background-color: #28a745 !important;
		border-color: #28a745 !important;
	}

	.pagination-sm .page-link {
		padding: 5px 12px !important;
		margin-top: 40px;
	}

	.page-link:focus {
		box-shadow: none !important;
	}
    .dataTable td{
        font-size: 14px;
    }
	.onPay{
		display: flex;
		justify-content: end;
	}
</style>



// WEBPACK FOOTER //
// src/view/intention-list/intention-detail.vue